





























import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';

import bffTextLabel from './bffTextLabel.vue';
import bffLine from './bffLine.vue';

import bffIconLabel from './bffIconLabel.vue';

@Component({
  components: { bffTextLabel, bffLine, bffIconLabel }
})
export default class BffCard extends Vue {
  @Prop({ default: '' }) title!: String;
  @Prop({ default: '' }) bodyTitle!: String;
  @Prop({ default: false }) showMore!: Boolean;

  @Emit('click') send(msg?: any) {}

  showMoreClick() {
    this.send();
  }
}
